import styled, { css } from 'styled-components';
import { SectionHeading, HighlightText } from '../../global/typography';

export const StyledSection = styled.section`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5rem 0;
    flex-direction: column;

    &::before {
        content: '';
        position: absolute;
        height: 100%;
        top: 0;
        width: 100vw;
        margin-left: 50%;
        left: -50vw;
        z-index: -2;
        background-color: ${props => props.theme.colors.primary};
    }

    & > .keen-slider {
        padding: 2rem 0;
    }

    @media (max-width: 757px) {
        padding: 2.185rem 0 4.375rem 0;
    }
`;

export const StyledContainer = styled.div`
    display: grid;
    gap: 30px;
    padding: 3.125rem 0.94rem;
    grid-template-columns: repeat(3, minmax(0, 1fr));

    @media (max-width: 979px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        padding: 3.125rem 0;
    }

    @media (max-width: 757px) {
        grid-template-columns: repeat(1, minmax(0, 1fr));
        padding: 2.185rem 0.94rem;
    }
`;

export const StyledHeading = styled(SectionHeading)`
    text-align: center;
    color: white;

    & > span.--green {
        color: ${props => props.theme.colors.primary};
        display: block;
    }
`;

export const StyledHeadingSpan = styled(SectionHeading)`
    display: block;
    text-align: start;
    font-weight: 600;
`;

export const StyledHighlight = styled.h4`
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

export const StyledLink = styled.a`
    font-size: 28px;
    line-height: 42px;
    font-weight: 600;
    text-align: center;
    text-decoration: underline;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LinkContainer = styled.div``;

export const StyledLinkReadMore = styled.a`
    color: white;
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.125rem;
    text-decoration: underline;

    &:hover {
        text-decoration: none;
        color: white;
    }
`;

export const SliderControlDiv = styled.div`
    background: transparent;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    padding-bottom: 2rem;

    span {
        font-size: 18px;

        @media (max-width: 979px) {
            font-size: 16px;
        }
    }

    svg {
        fill: white;
    }
`;
